import React, {  } from 'react';

import { displayNamesOptions } from '../types';
import { IntlFunction } from './Intl.Function';

export const IntlDisplayNamesResolvedOptions = () => (
	<IntlFunction
		input={[]}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames/resolvedOptions"
		header="Intl.DisplayNames.prototype.resolvedOptions"
		description="Returns a new object with properties reflecting the locale and style formatting options computed during the construction of the current [Intl.DisplayNames](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DisplayNames) object."
		options={displayNamesOptions}
		ruleSet={[]}
		template="new Intl.DisplayNames(##locale##, ##options##).resolvedOptions()" />
)